import { createRouter, createWebHistory } from 'vue-router'

import AllClubNews from './components/AllClubNews.vue'
import AllEvents from './components/AllEvents.vue'
import AllMainNews from './components/AllMainNews.vue'
import Clubs from './components/Clubs.vue'
import EditMainNews from './components/EditMainNews.vue'
import EditEvents from './components/EditEvents.vue'
import FocusNews from './components/FocusNews.vue'
import Home from './components/Home.vue'
import Login from './components/Login.vue'


const routes = [
  { path: '/', name: 'home', component: Home },
  { path: '/gemeinde-login', name: 'login', component: Login },
  { path: '/vereine', name: 'clubs', component: Clubs },
  { path: '/edit-main-news/:type', name: 'editMainNews', component: EditMainNews },
  { path: '/edit-events/', name: 'editEvents', component: EditEvents },
  { path: '/all-events', name: 'allEvents', component: AllEvents },
  { path: '/all-main-news/:type', name: 'allMainNews', component: AllMainNews },
  { path: '/all-club-news/:type', name: 'allClubNews', component: AllClubNews },
  { path: '/focus-news/:id', name: 'focusNews', component: FocusNews },

]

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkExactActiveClass: 'active',
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router